export default __webpack_public_path__ + "static/media/recovery-4.72cd858b.svg";